import { Alert, Button } from '@pms-digital/design-system';

interface ErreurHistoriqueProps {
  onReessayer: () => void;
}

/** The service cannot be reached, or answered something unexpected. */
export function ErreurHistorique({ onReessayer }: ErreurHistoriqueProps) {
  return (
    <Alert
      tone="danger"
      action={
        <Button type="button" variant="primary" onClick={onReessayer}>
          réessayer
        </Button>
      }
    >
      L'historique n'a pas pu être chargé.
    </Alert>
  );
}
